import { CollapsibleTrigger } from '@radix-ui/react-collapsible';
import { Icon } from 'semantic-ui-react';
import { ProjectArraysDisplay } from '~/constants';
import { ProjectArray } from '~/types/project';
import { formatNumber } from '~/utils';
import { System } from '~/utils/calculators';

export default function ProjectArraySectionHeader({
  projectArray,
  isCollapsed = false,
  onRemove,
}: {
  projectArray: ProjectArray,
  isCollapsed: boolean,
  onRemove: () => void,
}) {
  let arrayHeaderValues = '';
  if (projectArray.type) {
    arrayHeaderValues = ProjectArraysDisplay[projectArray.type];
  }
  if (projectArray.sizeKwdc) {
    if (arrayHeaderValues) {
      arrayHeaderValues += ', ';
    }
    arrayHeaderValues += `${formatNumber(projectArray.sizeKwdc)} kWdc`;
  }
  if (projectArray.sizeKwdc && projectArray.yearOneProduction && projectArray.yearOneProductionUnit) {
    const productionFactor = System.productionFactor(projectArray);
    arrayHeaderValues += `, ${formatNumber(productionFactor) || 0} kWh/kW`;
  }

  return (
    <div className="collapsible-card__header">
      <CollapsibleTrigger
        type="button"
        aria-label={isCollapsed ? 'Expand array' : 'Collapse array'}
        className="collapsible-card__trigger"
      >
        <span className="collapsible-card__caret">
          <Icon name={isCollapsed ? 'caret right' : 'caret down'} fitted />
        </span>
        <h3 className="collapsible-card__title">
          Array {projectArray.order + 1} - {arrayHeaderValues || 'TBD'}
        </h3>
      </CollapsibleTrigger>
      <div className="collapsible-card__controls">
        <button
          type="button"
          aria-label="Remove array"
          className="collapsible-card__remove"
          onClick={onRemove}
        >
          <Icon name="trash alternate outline" />
        </button>
      </div>
    </div>
  );
}
